/**
 * User API Client
 * API client for user-facing endpoints (topics, memories, birth charts)
 * Base URL: /v1 (not /v1/admin)
 */

import axios, { AxiosError } from 'axios';
import { API_BASE_URL } from './client';

export const userApiClient = axios.create({
  baseURL: `${API_BASE_URL}/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds
});

// Request interceptor - add auth headers
userApiClient.interceptors.request.use(
  (config) => {
    // Get user ID and token from localStorage
    const userId = localStorage.getItem('admin_user_id') || localStorage.getItem('user_id');
    const token = localStorage.getItem('admin_token') || sessionStorage.getItem('admin_token');

    if (userId) {
      config.headers['X-User-ID'] = userId;
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
userApiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      localStorage.removeItem('admin_token');
      sessionStorage.removeItem('admin_token');
      sessionStorage.setItem('admin_redirect_after_login', window.location.hash.slice(1) || '/');
      window.location.hash = '#/login';
    }

    // Extract error message
    const message = (error.response?.data as any)?.detail || error.message;
    return Promise.reject(new Error(message));
  }
);

export default userApiClient;
